import { ObjectTools } from '../../tools/object-tools';
import { SolIcon } from '@sol/icons';

export type SolTrendFavor = 'up' | 'down';

export class SolTrend {
  private constructor(
    public readonly amount: number,
    public readonly favor: SolTrendFavor,
    public readonly text: string,
    public readonly textParams: Record<string, any>,
    public readonly textTranslatable: boolean,
    public readonly textVisible: boolean,
    public readonly roundedAmount: number,
    public readonly icon: SolIcon,
    public readonly trendClass: string,
  ) {}

  public static of(amount: number, favor: SolTrendFavor = 'down'): SolTrend {
    return new SolTrend(amount, favor, '', {}, true, false, 0, SolIcon.trend_up, 'sol-trend').recalculate();
  }

  public withAmount(amount: number): SolTrend {
    return this.copy({ amount }).recalculate();
  }

  public withFavor(favor: SolTrendFavor): SolTrend {
    return this.copy({ favor }).recalculate();
  }

  public withText(text: string, textParams: Record<string, any> = {}): SolTrend {
    return this.copy({ text, textParams });
  }

  public withTextTranslatable(textTranslatable: boolean): SolTrend {
    return this.copy({ textTranslatable });
  }

  public withTextVisible(textVisible: boolean): SolTrend {
    return this.copy({ textVisible });
  }

  private recalculate(): SolTrend {
    const roundedAmount = Math.round(this.amount);
    const favorAmount = this.favor === 'up' ? roundedAmount : -roundedAmount;

    let trendClass = 'sol-trend';
    if (favorAmount > 0) {
      trendClass += ' sol-trend-up';
    } else if (favorAmount < 0) {
      trendClass += ' sol-trend-down';
    } else {
      trendClass += ' sol-trend-default';
    }

    let icon: SolIcon;
    if (roundedAmount > 0) {
      icon = SolIcon.trend_up;
    } else if (roundedAmount < 0) {
      icon = SolIcon.trend_down;
    } else {
      icon = SolIcon.arrow_right;
    }

    return this.copy({ roundedAmount, icon, trendClass });
  }

  private copy(props: Partial<SolTrend>): SolTrend {
    return ObjectTools.copy<SolTrend>(this, props);
  }
}
